import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const SPACINGTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SpacingType.Name')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .text('code', 'Entity.SpacingType.Code')
    .required()
    .minLength(1)
    .maxLength(1)
    .build(),
];

export const SPACINGTYPE_CONFIG = {
  entityName: 'SpacingType',
  localizationKey: 'Planning::Entity.SpacingType',
  fields: SPACINGTYPE_FIELDS,
  permission: 'PlanningOperation.SpacingTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.OperationPlanning + MENU_NAME_SUFFIX,
};
